import { createSlice } from '@reduxjs/toolkit'

const getInitialLanguage = () => {
  try {
    return localStorage.getItem('aether-language') || 'en-US'
  } catch {
    return 'en-US'
  }
}

const initialState = {
  currentStep: 1, // 1: 上传, 2: 选择风格, 3: 生成结果
  language: getInitialLanguage(), // 'zh-CN' | 'en-US'
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.currentStep = action.payload
    },
    nextStep: (state) => {
      if (state.currentStep < 3) {
        state.currentStep += 1
      }
    },
    prevStep: (state) => {
      if (state.currentStep > 1) {
        state.currentStep -= 1
      }
    },
    setLanguage: (state, action) => {
      state.language = action.payload
    },
    resetApp: (state) => {
      state.currentStep = 1
    },
  },
})

export const { setStep, nextStep, prevStep, setLanguage, resetApp } = appSlice.actions
export default appSlice.reducer
